import React, { type FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { streamViewTypeSelector } from 'redux-store/stream/stream.selectors'
import { StreamLabel } from 'components/cards/BroadcastThumbnail/ThumbnailLabel/ThumbnailLabel'
import { ViewType } from 'redux-store/stream/stream.interface'
import { NoBroadcastLabel } from 'components/cards/GameScheduleCard/GameScheduleButtons/NoBroadcastLabel'
import { ProducedBy } from 'features/viewerPage/components/ProducedBy/ProducedBy'

import { type GameWithoutLivestream } from '../../types'

import styles from './StreamInfo.module.scss'
import { channelSelector } from 'redux-store/channel/channel.selectors'

type StreamInfoProps = {
  mediaObject: GameWithoutLivestream
}

export const StreamInfo: FC<StreamInfoProps> = ({ mediaObject }) => {
  const [shouldBeLive, setShouldBeLive] = useState(false)
  const now = Date.now() / 1000
  const streamTitle = mediaObject.title
  const liveStartAt = mediaObject.start_at
  const isReplay = mediaObject?.is_replay
  const publishedAt = mediaObject.start_at
  const startAt = mediaObject.start_at
  const highlightFromDate = null
  const streamType = useSelector(streamViewTypeSelector)
  const type = mediaObject.type
  const producer = mediaObject.producer
  const subTitle = mediaObject.categories[0]?.name
  const isLive = [ViewType.LIVE].includes(streamType)
  const isNoPastStream = [ViewType.NO_PAST_LIVESTREAM].includes(streamType)
  const channel = useSelector(channelSelector)
  const channelSlug = channel?.data?.subdomain

  useEffect(() => {
    if (liveStartAt && liveStartAt < now && isLive) {
      setShouldBeLive(true)
    }
  }, [now, liveStartAt, isLive, streamType])

  console.log(channel)

  return (
    <div className={styles.Container}>
      {isNoPastStream && (
        <div className={styles.NoBroadcastLabel}>
          <NoBroadcastLabel channelSlug={channelSlug} id={mediaObject.id!} />
        </div>
      )}
      <div className={styles.MainText}>
        <h1 data-testid="stream-title" className={styles.StreamTitle}>
          {streamTitle}
        </h1>
        {subTitle && (
          <h2 data-testid="stream-sub-title" className={styles.SubTitle}>
            {subTitle}
          </h2>
        )}
      </div>
      <div className={styles.Label}>
        <StreamLabel
          isLive={shouldBeLive}
          isReplay={isReplay || false}
          highlightFromDate={highlightFromDate}
          publishedAt={publishedAt!}
          startAt={startAt!}
          type={type || 'game'}
        />
      </div>
      {channel?.data?.name && (
        <div className={styles.CompanyLabel}>{channel?.data?.name || ''}</div>
      )}
    </div>
  )
}
